import { Search2Icon } from "@chakra-ui/icons";
import {
    Tag,
    TagLabel,
    TagCloseButton,
    Checkbox,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    Input,
    InputGroup,
    InputLeftElement
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { BsFillStarFill } from "react-icons/bs";
import { HiLockClosed } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { MemoriesModelQuery } from "../../models/collaborate.model";
import {
    checkAllSegregatedMemories,
    checkSegregatedMemory,
    checkThirdPartyMemory,
    selectIsAllMemoriesSelected,
    selectSegregatedMemories,
    selectThirdPartyMemories,
    setIsAllMemoriesSelected,
    uncheckAllSegregatedMemories
} from "../../store/slices/node.slice";

const MemoriesControlPanel: React.FC = () => {
    // const nodesDataState: NodeState = useSelector((state: any) => state.nodeData);

    // const memories_state = useSelector(selectedMemories);
    const isAllMemoriesSelected: boolean = useSelector(selectIsAllMemoriesSelected);
    const segregatedMemories = useSelector(selectSegregatedMemories);
    const thirdPartyMemories = useSelector(selectThirdPartyMemories);
    // const useRLHFSearch: boolean = useSelector((state: { nodeData: NodeState }) => state.nodeData.useRLHFSearch);
    // const shouldSearchNotes: boolean = useSelector((state: { nodeData: NodeState }) => state.nodeData.shouldSearchNotes);
    const [searchThirdPartyMemoriesList, setSearchThirdPartyMemoriesList] = useState<
        MemoriesModelQuery[]
    >([]);

    const dispatch = useDispatch();

    // const checkShouldSearchNotes = (checked: boolean) => {
    //     dispatch(setShouldSearchNotes(checked));
    // };

    const isAllSegregatedMemoriesSelected = () =>
        segregatedMemories.every((memory) => memory.isSelected);

    // const setThirdPartyGeneralMemories = () => {
    //     if (thirdPartyMemories.length === 0) {
    //         const generalMemoriesTemp = memories_state
    //             .filter(
    //                 (memory) =>
    //                     memory.brain_type === MemoryBrainType.THIRD_PARTY,
    //             )
    //             .map((memory) => ({ ...memory, isSelected: false }));

    //         dispatch(setThirdPartyMemories(generalMemoriesTemp));
    //     }
    // };

    const selectAllSegregated = (e) => {
        const checked = e.target.checked;

        if (checked) {
            dispatch(checkAllSegregatedMemories());
        } else {
            dispatch(uncheckAllSegregatedMemories());
        }
    };

    const unCheckAllSegregatedSectors = () => {
        dispatch(uncheckAllSegregatedMemories());
    };

    const checkSegregatedSector = (memoryId: string, checked: boolean) => {
        dispatch(checkSegregatedMemory({ id: memoryId, checked }));
        // If checked is false, unchecked all segregated
        if (!checked && isAllMemoriesSelected) {
            dispatch(setIsAllMemoriesSelected(false));
        }
    };

    const checkThirdParySector = (memoryId: string, checked: boolean) => {
        dispatch(checkThirdPartyMemory({ id: memoryId, checked }));
    };

    const onSelectAllMemories = (e) => {
        const checked = e.target.checked;
        // dispatch(setMemoriesChecklist(checked ? "All" : "Segregated"));
        dispatch(setIsAllMemoriesSelected(checked));
        if (checked) {
            dispatch(checkAllSegregatedMemories());
        } else {
            dispatch(uncheckAllSegregatedMemories());
        }
    };

    // This function is fired the "x" icon on the all memories is clicked
    function onDeselectAllMemories() {
        dispatch(setIsAllMemoriesSelected(false));
        dispatch(uncheckAllSegregatedMemories());
    }

    // a function that searches through general memories by sector property
    const searchGeneralMemories = (e: any) => {
        const query: string = e.target.value;
        if (query.length > 0) {
            const memories = thirdPartyMemories.filter((memory) =>
                memory.sector.toLowerCase().includes(query.toLowerCase())
            );
            setSearchThirdPartyMemoriesList(memories);
        } else {
            setSearchThirdPartyMemoriesList([]);
        }
    };

    // const onRLHFSearchChange = (e) => {
    //     dispatch(setUseRLHFSearch(e.target.checked));
    // };

    // const onSearchNotesChange = (e) => {
    //     checkShouldSearchNotes(e.target.checked);
    // };

    // const handleAllClick = () => {
    //     // Implement logic for what happens when "All" is clicked
    //     // console.log("All clicked");
    // };

    return (
        <div id="memories-control-panel" className="memories-control panel-contents">
            <div className="control-panel-header">
                <h1 className="title">Memories</h1>
                <h2 className="subtitle">Manage the memories of your cell</h2>
            </div>

            <h2 className="panel-title">Memories of the Cell</h2>
            <div className="chips-container">
                {isAllMemoriesSelected ? (
                    <Tag
                        size={"md"}
                        className="mr-2 mb-1"
                        borderRadius="full"
                        variant="subtle"
                        colorScheme="blue"
                    >
                        <TagLabel>All</TagLabel>
                        <TagCloseButton onClick={onDeselectAllMemories} />
                    </Tag>
                ) : (
                    <>
                        {isAllSegregatedMemoriesSelected() ? (
                            <Tag
                                size={"md"}
                                className="mr-2 mb-1"
                                borderRadius="full"
                                variant="subtle"
                                colorScheme="blue"
                            >
                                <TagLabel>All (Segregated)</TagLabel>
                                <TagCloseButton onClick={unCheckAllSegregatedSectors} />
                            </Tag>
                        ) : (
                            segregatedMemories.map((sector, index) => {
                                if (sector.isSelected) {
                                    return (
                                        <Tag
                                            size={"md"}
                                            key={`seg-sector-tag-${index}`}
                                            className="mr-2 mb-1"
                                            borderRadius="full"
                                            variant="subtle"
                                            colorScheme="blue"
                                        >
                                            <TagLabel>{sector.sector_display}</TagLabel>
                                            <TagCloseButton
                                                onClick={() =>
                                                    checkSegregatedSector(sector.id, false)
                                                }
                                            />
                                        </Tag>
                                    );
                                } else {
                                    return null;
                                }
                            })
                        )}
                    </>
                )}
                {thirdPartyMemories.map((sector, index) => {
                    if (sector.isSelected) {
                        return (
                            <Tag
                                size={"md"}
                                key={`seg-sector-tag-${index}`}
                                className="mr-2 mb-1"
                                borderRadius="full"
                                variant="solid"
                                colorScheme="blue"
                            >
                                <TagLabel>{sector.sector_display}</TagLabel>
                                <TagCloseButton
                                    onClick={() => checkThirdParySector(sector.id, false)}
                                />
                            </Tag>
                        );
                    } else {
                        return null;
                    }
                })}
            </div>

            {/* <div className="checkbox-container all-memories-checkbox">
                <input id="check-all-memories" type="checkbox" defaultChecked />
                <span className="label-text">All Memories</span>
            </div> */}
            <div className="mb-2 mt-2 checkbox-container all-memories-checkbox">
                <Checkbox isChecked={isAllMemoriesSelected} onChange={onSelectAllMemories}>
                    <span className="title-style">All Memories</span>
                </Checkbox>
            </div>
            <Tabs colorScheme="blue">
                <TabList>
                    <Tab>
                        <HiLockClosed />
                        &nbsp;<span className="text-sm tab-header-style">Segregated</span>
                    </Tab>
                    <Tab>
                        &nbsp;<span className="text-sm tab-header-style">Third Party</span>
                    </Tab>
                </TabList>

                <TabPanels>
                    <TabPanel pl={4} pr={0}>
                        <div>
                            <Checkbox
                                isChecked={isAllSegregatedMemoriesSelected()}
                                onChange={selectAllSegregated}
                            >
                                <span className="title-style">All</span>
                            </Checkbox>
                        </div>
                        <div className="pl-2 pt-1">
                            {segregatedMemories.map((sector, index) => {
                                return (
                                    <SegregatedSectorCard
                                        key={`seg-sector-${index}`}
                                        title={sector.sector_display}
                                        description={sector.sector_description}
                                        isSelected={sector.isSelected}
                                        onChanged={(checked) =>
                                            checkSegregatedSector(sector.id, checked)
                                        }
                                    />
                                );
                            })}
                        </div>
                    </TabPanel>
                    <TabPanel pl={4} pr={0}>
                        <div className="sector-memory-card-search-input-group mb-3 input-group input-background">
                            <InputGroup>
                                <InputLeftElement pointerEvents="none">
                                    <Search2Icon color="gray.300" />
                                </InputLeftElement>
                                <Input
                                    placeholder="Search..."
                                    type="text"
                                    onChange={searchGeneralMemories}
                                />
                            </InputGroup>
                        </div>

                        {searchThirdPartyMemoriesList.map((sector, index) => {
                            return (
                                <GeneralSectorCard
                                    key={`gen-sector-${index}`}
                                    title={sector.sector_display}
                                    description={sector.sector_description}
                                    isSelected={sector.isSelected}
                                    onChanged={(checked) =>
                                        checkThirdParySector(sector.id, checked)
                                    }
                                />
                            );
                        })}
                    </TabPanel>
                </TabPanels>
            </Tabs>

            {/* <div id="memories-tab" className="tab-container">
                <ul className="tab-header">
                    <li className="tab-header-item">
                        <a href="#segrated-tab">Segregated</a>
                    </li>
                    <li className="tab-header-item">
                        <a href="#third-party-tab">Third Party</a>
                    </li>
                </ul>
                <div id="segrated-tab" className="tab-body">
                    <div className="checkbox-container">
                        <input id="check-seg-all" type="checkbox" defaultChecked />
                        <span className="label-text">All</span>
                    </div>
                    <div id="segrated-memories-container" className="segrated-memories-section"></div>
                </div>
                <div id="third-party-tab" className="tab-body">
                    <div className="autocomplete">
                        <div className="input-group">
                            <input type="text" id="third-party-search-input" className="input search-input"
                                placeholder="Search..." />
                        </div>
                        <div className="autocomplete-list"></div>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

interface SegregatedSectorCardProps {
    title: string;
    description: string;
    hideCheckBox?: boolean;
    onChanged?: (checked: boolean) => void;
    onClick?: () => void;
    isSelected?: boolean;
}

function SegregatedSectorCard(props: SegregatedSectorCardProps) {
    const [isChecked, setIsChecked] = useState<boolean>(false);

    useEffect(() => {
        setIsChecked(props.isSelected || false);
    }, [props.isSelected]);

    const onChange = (checked: boolean) => {
        setIsChecked(checked);
        if (props.onChanged) {
            props.onChanged(checked);
        } // Call the onChanged function if it exists
    };

    const clickEvent = () => {
        if (typeof props.onClick === "function") {
            props.onClick();
        }
    };

    return (
        <div onClick={clickEvent} className="sector-memory-card">
            {!props.hideCheckBox && (
                <div className="pt-2">
                    <Checkbox isChecked={isChecked} onChange={(e) => onChange(e.target.checked)} />
                </div>
            )}
            <div className="">
                <p className="sector-title truncate mb-1" title={props.title}>
                    {props.title}
                </p>
                <p title={props.description} className="sector-description text-slate-500 text-sm">
                    {props.description}
                </p>
            </div>
        </div>
    );
}

function GeneralSectorCard(props: SegregatedSectorCardProps) {
    const [isChecked, setIsChecked] = useState<boolean>(false);

    useEffect(() => {
        setIsChecked(props.isSelected || false);
    }, [props.isSelected]);

    const onChange = (checked: boolean) => {
        setIsChecked(checked);
        if (props.onChanged) {
            props.onChanged(checked);
        } // Call the onChanged function if it exists
    };
    return (
        <div className="sector-memory-card">
            <div className="pt-1">
                <Checkbox isChecked={isChecked} onChange={(e) => onChange(e.target.checked)} />
            </div>
            <div className="">
                <div className="sector-title general-title mb-1" title={props.title}>
                    <p className="truncate">{props.title}</p>
                </div>
                <p
                    title={props.description}
                    className="sector-description text-slate-500 mb-2 text-sm"
                >
                    {props.description}
                </p>
                <div className="sector-card-footer flex justify-between items-center py-2">
                    <p className="flex items-center">
                        <span className="text-xs text-slate-700">4.5</span>
                        &nbsp;
                        <BsFillStarFill className="rating-icon" />
                    </p>
                    <p
                        title={props.description}
                        className="sector-description text-slate-500 text-xs text-right"
                    >
                        +$0.001/Word
                    </p>
                </div>
            </div>
        </div>
    );
}

export default MemoriesControlPanel;
